import produce from 'immer';
import {
	GET_FAMILY_MEMBERS_ERROR,
	GET_FAMILY_MEMBERS_PENDING,
	GET_FAMILY_MEMBERS_SUCCESS,
	GET_POSTAL_CODES_FOR_ADDRESS_ERROR,
	GET_POSTAL_CODES_FOR_ADDRESS_PENDING,
	GET_POSTAL_CODES_FOR_ADDRESS_SUCCESS,
	UPDATE_FAMILY_MEMBERS_ADDRESS_ERROR,
	UPDATE_FAMILY_MEMBERS_ADDRESS_PENDING,
	UPDATE_FAMILY_MEMBERS_ADDRESS_SUCCESS,
} from '../constants/actions/familyMembersActions';
import { LOGOUT_FULFILLED } from '../constants/actions/userProfileActions';
import IFamilyMembersReducer from '../interfaces/reducers/familyMembersReducer';

const initialValues: IFamilyMembersReducer = {
	family: null,
	addresses: null,
	address: '',
	loading: false,
	error: false,
};

const familyMembersReducer = produce((draft, action) => {
	switch (action.type) {
		case GET_FAMILY_MEMBERS_SUCCESS: {
			draft.family = action.payload;
			draft.loading = false;
			draft.error = false;
			break;
		}
		case GET_FAMILY_MEMBERS_PENDING: {
			draft.loading = true;
			draft.error = false;
			break;
		}
		case GET_FAMILY_MEMBERS_ERROR: {
			draft.loading = false;
			draft.error = true;
			break;
		}
		case UPDATE_FAMILY_MEMBERS_ADDRESS_SUCCESS: {
			draft.loading = false;
			draft.error = false;
			break;
		}
		case UPDATE_FAMILY_MEMBERS_ADDRESS_PENDING: {
			draft.loading = true;
			draft.error = false;
			break;
		}
		case UPDATE_FAMILY_MEMBERS_ADDRESS_ERROR: {
			draft.loading = false;
			draft.error = true;
			break;
		}
		case GET_POSTAL_CODES_FOR_ADDRESS_SUCCESS: {
			draft.addresses = action.payload.addresses;
			draft.address = action.payload.address;
			draft.loading = false;
			draft.error = false;
			break;
		}
		case GET_POSTAL_CODES_FOR_ADDRESS_PENDING: {
			draft.loading = true;
			draft.error = false;
			break;
		}
		case GET_POSTAL_CODES_FOR_ADDRESS_ERROR: {
			draft.loading = false;
			draft.error = true;
			break;
		}
		case LOGOUT_FULFILLED: {
			return initialValues;
		}
		default:
			break;
	}
}, initialValues);

export default familyMembersReducer;
